import { render, staticRenderFns } from "./WhatsappForm.vue?vue&type=template&id=26638643&scoped=true"
import script from "./WhatsappForm.vue?vue&type=script&lang=js"
export * from "./WhatsappForm.vue?vue&type=script&lang=js"
import style0 from "./WhatsappForm.vue?vue&type=style&index=0&id=26638643&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26638643",
  null
  
)

export default component.exports